import React, { Component } from 'react';
import { createStyles, Theme, withStyles, WithStyles, makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

// export const APP_DOMAIN = "http://18.136.119.55";
export const APP_DOMAIN = "https://api.chumsda.org"; //"http://sda-web-api.demo-uat.com"; //"http://127.0.0.1:8000";//
export const RESOURCE_URL = "https://sdaapp.net:8443/bible-cms/uploads/";

export const BOOK_ID_NAME_TC = [{"id":1,"name":"創世記"},{"id":2,"name":"出埃及記"},{"id":3,"name":"利未記"},{"id":4,"name":"民數記"},{"id":5,"name":"申命記"},{"id":6,"name":"約書亞記"},{"id":7,"name":"士師記"},{"id":8,"name":"路得記"},{"id":9,"name":"撒母耳記上"},{"id":10,"name":"撒母耳記下"},{"id":11,"name":"列王紀上"},{"id":12,"name":"列王紀下"},{"id":13,"name":"歷代志上"},{"id":14,"name":"歷代志下"},{"id":15,"name":"以斯拉記"},{"id":16,"name":"尼希米記"},{"id":17,"name":"以斯帖記"},{"id":18,"name":"約伯記"},{"id":19,"name":"詩篇"},{"id":20,"name":"箴言"},{"id":21,"name":"傳道書"},{"id":22,"name":"雅歌"},{"id":23,"name":"以賽亞書"},{"id":24,"name":"耶利米書"},{"id":25,"name":"耶利米哀歌"},{"id":26,"name":"以西結書"},{"id":27,"name":"但以理書"},{"id":28,"name":"何西阿書"},{"id":29,"name":"約珥書"},{"id":30,"name":"阿摩司書"},{"id":31,"name":"俄巴底亞書"},{"id":32,"name":"約拿書"},{"id":33,"name":"彌迦書"},{"id":34,"name":"那鴻書"},{"id":35,"name":"哈巴谷書"},{"id":36,"name":"西番雅書"},{"id":37,"name":"哈該書"},{"id":38,"name":"撒迦利亞書"},{"id":39,"name":"瑪拉基書"},{"id":40,"name":"馬太福音"},{"id":41,"name":"馬可福音"},{"id":42,"name":"路加福音"},{"id":43,"name":"約翰福音"},{"id":44,"name":"使徒行傳"},{"id":45,"name":"羅馬書"},{"id":46,"name":"哥林多前書"},{"id":47,"name":"哥林多後書"},{"id":48,"name":"加拉太書"},{"id":49,"name":"以弗所書"},{"id":50,"name":"腓利比書"},{"id":51,"name":"歌羅西書"},{"id":52,"name":"帖撒羅尼迦前書"},{"id":53,"name":"帖撒羅尼迦後書"},{"id":54,"name":"提摩太前書"},{"id":55,"name":"提摩太後書"},{"id":56,"name":"提多書"},{"id":57,"name":"腓利門書"},{"id":58,"name":"希伯來書"},{"id":59,"name":"雅各書"},{"id":60,"name":"彼得前書"},{"id":61,"name":"彼得後書"},{"id":62,"name":"約翰壹書"},{"id":63,"name":"約翰貳書"},{"id":64,"name":"約翰參書"},{"id":65,"name":"猶大書"},{"id":66,"name":"啟示錄"}];
export const BOOK_ID_NAME_CN = [{"id":1,"name":"创世记"},{"id":2,"name":"出埃及记"},{"id":3,"name":"利未记"},{"id":4,"name":"民数记"},{"id":5,"name":"申命记"},{"id":6,"name":"约书亚记"},{"id":7,"name":"士师记"},{"id":8,"name":"路得记"},{"id": 9,"name":"撒母耳记上"},{"id":10,"name":"撒母耳记下"},{"id":11,"name":"列王纪上"}, {"id":12,"name":"列王纪下"},{"id":13,"name":"历代志上"},{"id":14,"name":"历代志下"},{"id":15,"name":"以斯拉记"},{"id":16,"name":"尼希米记"},{"id":17, "name":"以斯帖记"},{"id":18,"name":"约伯记"},{"id":19,"name":"诗篇"},{"id" :20,"name":"箴言"},{"id":21,"name":"传道书"},{"id":22,"name":"雅歌"},{"id" :23,"name":"以赛亚书"},{"id":24,"name":"耶利米书"},{"id":25,"name":"耶利米哀歌"},{"id":26,"name":"以西结书"},{"id":27,"name":"但以理书"},{"id":28,"name" :"何西阿书"},{"id":29,"name":"约珥书"},{"id":30,"name":"阿摩司书"},{"id": 31,"name":"俄巴底亚书"},{"id":32,"name":"约拿书"},{"id":33,"name":"弥迦书"} ,{"id":34,"name":"那鸿书"},{"id":35,"name":"哈巴谷书"},{"id":36,"name":"西番雅书"},{"id":37,"name":"哈该书"},{"id":38,"name":"撒迦利亚书"},{"id":39 ,"name":"玛拉基书"},{"id":40,"name":"马太福音"},{"id":41,"name":"马可福音"},{ "id":42,"name":"路加福音"},{"id":43,"name ":"约翰福音"},{"id":44,"name":"使徒行传"},{"id":45,"name":"罗马书"},{"id":46, "name":"哥林多前书"},{"id":47,"name":"哥林多后书"},{"id":48,"name":"加拉太书" },{"id":49,"name":"以弗所书"},{"id":50,"name":"腓利比书"},{"id":51,"name" :"歌罗西书"},{"id":52,"name":"帖撒罗尼迦前书"},{"id":53,"name":"帖撒罗尼迦后书"} ,{"id":54,"name":"提摩太前书"},{"id":55,"name":"提摩太后书"},{"id":56,"name" :"提多书"},{"id":57,"name":"腓利门书"},{"id":58,"name":"希伯来书"},{"id" :59,"name":"雅各书"},{"id":60,"name":"彼得前书"},{"id":61,"name":"彼得后书"}, {"id":62,"name":"约翰壹书"},{"id":63,"name":"约翰贰书"},{"id":64,"name":"约翰参书"},{"id":65,"name":"犹大书"},{"id":66,"name":"启示录"}];
export const CONTENT_VERSION_TC_EN = [{"id": "tc", "name": "和合本"},{"id": "tc_cmn", "name": "新標點和合本"},{"id": "tc_rcuv", "name": "和合本修訂版"},{"id": "en", "name": "KJV"},{"id": "en_nrsv", "name": "NRSV"},{"id": "en_nasb", "name": "NASB"},];
export const CONTENT_VERSION_CN_EN = [{"id": "cn", "name": "和合本"},{"id": "cn_rcuv", "name": "新标点和合本"},{"id": "en", "name": "KJV"},{"id": "en_nrsv", "name": "NRSV"},{"id": "en_nasb", "name": "NASB"},];

export const zeroPad = (num, places) => String(num).padStart(places, '0');

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      display: 'block',
      marginTop: theme.spacing(2),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  }),
);

export const IOSSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: theme.spacing(1),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#52d869',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#52d869',
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 24,
      height: 24,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }),
)(({ classes, ...props }: Props) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});
